import { faHdd } from "@fortawesome/pro-solid-svg-icons/faHdd";
import { faUsers } from "@fortawesome/pro-solid-svg-icons/faUsers";
import * as api from "api/Core";
import { AppMessageBox } from "components/AppMessageBox";
import { SpinnerIndicator } from "components/CallServer";
import DashListBox, { DashBoxListItem } from "components/Dashboard/DashListBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import { Formaters } from "lib/Formarters";
import { DashboardConsumptionResumeModel, DashboardConsumptionSummaryColumn } from "models/ApiModels";
import moment from "moment";
import * as React from "react";
import { CommonProps } from "views/Dashboards/ConsumptionAnalysisDashboard";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    activeTile: DashboardConsumptionSummaryColumn;
    onChange: (tile: DashboardConsumptionSummaryColumn) => void;
}

interface IState {
    data: DashboardConsumptionResumeModel;
    loading: boolean;
}

type Props = IProps & CommonProps;

/////////////////////////////////////////////////////////////////////////////////////

class ConsumptionAnalysisTiles extends React.PureComponent<Props, IState>
{
    constructor(props: Props) {
        super(props);

        this.state = {
            data: null,
            loading: true,
        };
    }

    ///
    private loadData() {

        var ds = moment().utc().startOf("month");

        this.setState({ loading: true });

        api.getDashboardConsumptionAnalysis(
            {
                columnToSummary: DashboardConsumptionSummaryColumn.Resume,
                startDate: ds.toDate(),
                endDate: null,
            })
            .then((result) => {
                this.setState({ data: result.data, loading: false });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false });
            });
    }

    ///
    private handleTileClick(tile: DashboardConsumptionSummaryColumn) {
        this.props.onChange(tile);
    }

    ///
    public componentDidMount() {
        this.loadData();
    }

    ///
    private renderBoxes() {
        const { loading, data } = this.state;
        const { activeTile } = this.props;
        const inThisMonth = this.props.t("Views.Dashboards.Common.InThisMonth").toLowerCase();

        var boxes: DashBoxListItem[] = [
            {
                key: DashboardConsumptionSummaryColumn.Users,
                title: loading ? <SpinnerIndicator /> : data.totalUsers.toLocaleString(),
                subtitle: this.props.t("Views.Dashboards.ConsumptionAnalysis.AnalysisTiles.UsersSubtitle"),
                description: loading ? "" :  `${data.diffUsers > 0 ? "+ " : ""}${data.diffUsers.toLocaleString()} ${inThisMonth}`,
                icon: faUsers,
            },
            {
                key: DashboardConsumptionSummaryColumn.Storage,
                title: loading ? <SpinnerIndicator /> : Formaters.fileSize(data.totalSize).toLocaleString(),
                subtitle: this.props.t("Views.Dashboards.ConsumptionAnalysis.AnalysisTiles.StorageSubtitle"),
                description: loading ? "" : `${data.diffSize > 0 ? "+ " : ""}${Formaters.fileSize(data.diffSize).toLocaleString()} ${inThisMonth}`,
                icon: faHdd,
            }
        ];

        return (
            <>
                <DashListBox
                    color="warning"
                    boxes={boxes}
                    active={activeTile}
                    onClick={
                        (key: DashboardConsumptionSummaryColumn) => {
                            if (key != activeTile) this.handleTileClick(key);
                        }
                    }
                />
            </>
        );
    }

    ///
    public render() {

        const { data, loading } = this.state;

        return (
            <MuiContainer margin="normal" >
                {
                    !loading && data == null
                        ? <AppMessageBox resource="LoadGraphDataFailed" />
                        : this.renderBoxes()
                }
            </MuiContainer>
        );
    }
}

export default ConsumptionAnalysisTiles;